export default __webpack_public_path__ + "locales/sq-AL/InviteDialog.json?hash=754a03efd4f544ce5a4997a88a22004b";